import React, { useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Close } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import { formStyles } from '../../../util/styles';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { FormLabel } from '@mui/material';
import CreatableGroupSelect from '../CreatableGroupSelect';
import axios from 'axios';

const SelectGroupModal = ({ open, onClose, userData }) => {
  if (!userData) {
    return null;
  }

  const classes = formStyles();
  const [group, setGroup] = useState({});
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleDelete = async () => {
    let errorList = [];

    if (!group) {
      errorList.push('User must be part of a group');
    }

    if (errorList.length > 0) {
      setErrors(errorList);
    } else {
      try {
        const deleteUserBody = {
          email: userData.email,
          groupId: group.groupID,
        };
        setIsLoading(true);
        const res = await axios.delete('/api/user', {
          data: deleteUserBody,
        });
        setIsLoading(false);
        onClose(true);
      } catch (error) {
        setIsLoading(false);
        setErrors([error]);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      className={classes.form}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ pr: 6 }}>
        Delete User
        <IconButton
          aria-label="close"
          onClick={handleClose}
          disabled={isLoading}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
          size="large">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Collapse in={errors && errors.length > 0}>
          <Alert severity="error" className={classes.alert}>
            Edit Failed:
            <ul>
              {errors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </Alert>
        </Collapse>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography>
              The user to be deleted is the last in their group.
              Please choose a group to move the associated cases to.
            </Typography>
          </Grid>
          <Grid size={12}>
            <FormLabel component={'legend'}>Group</FormLabel>
            <CreatableGroupSelect
              create={false}
              value={{
                label: group.groupName,
                value: group.groupID,
              }}
              onChange={(group) => {
                setGroup({
                  groupName: group.label,
                  groupID: group.value,
                });
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={handleDelete}
          color="primary"
          variant="contained"
          disabled={isLoading || !Object.keys(group).length || group.groupID === userData.groupID}
        >
          {isLoading ? 'Deleting...' : 'Delete & Move Cases'}
        </Button>
        <Button
          onClick={handleClose}
          color="primary"
          disabled={isLoading}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectGroupModal;
